// @ts-nocheck
const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const cloneScopeValue = (value) => {
    if (Array.isArray(value)) {
        return value.map(cloneScopeValue);
    }

    if (isPlainObject(value)) {
        return Object.fromEntries(
            Object.entries(value).map(([key, nestedValue]) => [key, cloneScopeValue(nestedValue)]),
        );
    }

    return value;
};

export const mergeScopeValues = (left, right) => {
    if (left === undefined) {
        return cloneScopeValue(right);
    }

    if (right === undefined) {
        return cloneScopeValue(left);
    }

    if (typeof left === 'boolean' && typeof right === 'boolean') {
        return left || right;
    }

    if (typeof left === 'boolean') {
        return left ? true : cloneScopeValue(right);
    }

    if (typeof right === 'boolean') {
        return right ? true : cloneScopeValue(left);
    }

    if (isPlainObject(left) && isPlainObject(right)) {
        const merged = cloneScopeValue(left);

        Object.entries(right).forEach(([key, value]) => {
            merged[key] = mergeScopeValues(left[key], value);
        });

        return merged;
    }

    return cloneScopeValue(right);
};

export const buildRequestedSharingScopesFromOrder = (order) => {
    const mergedRequiredScopes = (order?.items || [])
        .map((item) => item?.product?.requiredScopes)
        .filter(Boolean)
        .reduce((accumulator, scopes) => mergeScopeValues(accumulator, scopes), {});

    return [{ type: 'self', ...mergedRequiredScopes }];
};

export const getEffectiveOrderSharings = (order, fallbackSharings = []) => {
    if (order?.sharings?.length) {
        return order.sharings;
    }

    return fallbackSharings || [];
};

const getSharingTimelineTimestamp = (sharing = { updatedAt: undefined, createdAt: undefined, expiry: undefined }) => {
    const activityTimestamps = [sharing?.updatedAt, sharing?.createdAt]
        .map((value) => Date.parse(value || ''))
        .filter((value) => Number.isFinite(value));

    if (activityTimestamps.length) {
        return Math.max(...activityTimestamps);
    }

    const expiryTimestamp = Date.parse(sharing?.expiry || '');
    return Number.isFinite(expiryTimestamp) ? expiryTimestamp : 0;
};

export const getLatestOrderSharing = (order, fallbackSharings = []) => getEffectiveOrderSharings(order, fallbackSharings)
    .filter((sharing) => sharing?.sharingId)
    .sort((left, right) => getSharingTimelineTimestamp(right) - getSharingTimelineTimestamp(left))[0] || null;

export const getRenewableOrderSharing = (order, fallbackSharings = []) => getEffectiveOrderSharings(order, fallbackSharings)
    .filter((sharing) => sharing?.sharingId && sharing?.status === 'accepted' && !!sharing?.expiry)
    .sort((left, right) => getSharingTimelineTimestamp(right) - getSharingTimelineTimestamp(left))[0] || null;

export const isOrderSharingMissing = (order, fallbackSharings = []) => !order?.customer?.userId || getEffectiveOrderSharings(order, fallbackSharings).length === 0;
